var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{ md: _vm.md }},[_c('div',{staticClass:"card-header",class:_vm.headerClass},[_vm._t("header")],2),_c('div',{class:_vm.contentClass},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }